/**
 * SkipToMain — keyboard-first accessibility landmark.
 *
 * Hidden until it receives focus (first Tab press). Targets the element
 * with `id="main-content"` inside the host shell. Visual styles live in
 * each app's MuiCssBaseline override (reads from design tokens so the
 * ring matches the active brand / theme mode).
 */

export default function SkipToMain() {
  return (
    <a className="skip-to-main" href="#main-content">
      Skip to main content
    </a>
  );
}
